import React from "react";

import { SearchTextField } from "../../../components/TextField";
import HistoryTable from "./HistoryTable";
import { Fade, Grid, Typography } from "@material-ui/core";

import { connect } from "react-redux";

import CustomPagination from "../../../components/CustomPagination";
import { useStyles } from "../../../styles/mainStyles";

const History = () => {
  let border = useStyles();
  return (
    <Fade in={true} timeout={500}>
      <Grid container justifyContent="center" style={{ height: "100%" }}>
        <Grid
          container
          item
          xs={12}
          spacing={2}
          style={{
            backgroundColor: "white",
            boxShadow: "0 3px 6px rgba(0,0,0,0.3)",
            borderRadius: 6,
            height: "100%",
          }}
        >
          <Grid item xs={12} style={{}}>
            <Typography variant="body1">سفارش ها</Typography>
          </Grid>
          <Grid
            item
            xs={12}
            container
            style={{ height: "90%", margin: 8 }}
            className={border.border}
          >
            <Grid
              container
              item
              md={12}
              direction="row"
              justifyContent="space-between"
              alignItems="flex-start"
              style={{ height: 50 }}
            >
              <Grid item sm={9} xs={7}>
                <SearchTextField />
              </Grid>
            </Grid>
            <Grid
              item
              xs={12}
              container
              style={{
                height: "calc(100% - 50px)",
                border: `1.9px solid #E8E8EF`,
              }}
            >
              <Grid
                item
                style={{
                  width: "100%",
                  height: "calc(100% - 80px)",
                }}
              >
                <HistoryTable />
                {/* <HistoryMaterialTable /> */}
              </Grid>

              <Grid
                item
                xs={12}
                style={{
                  alignSelf: "flex-end",
                }}
              >
                <CustomPagination />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Fade>
  );
};
const mapStateToProps = (props) => {
  return {};
};

export default connect(mapStateToProps)(History);
